import ApiVolumesTrims from '../../api/volumestrims';

const getVolumesStarted = () => ({
    type: 'GET_VOLUMES_STARTED'
});

const getVolumesSuccess = items => ({
    type: 'GET_VOLUMES_SUCCESS',
    payload: items
});

const getVolumesFailure = error => ({
    type: 'GET_VOLUMES_FAILURE',
    payload: { error }
});

const getVolumes = () => {

    return dispatch => {

        dispatch(getVolumesStarted());

        ApiVolumesTrims.getVolumes()
            .then(json =>  {
                let items = json.volumes;
                items = items.sort((a, b) => Number(a.volume) - Number(b.volume));
                dispatch(getVolumesSuccess({ items })) 
            })
            .catch(error => dispatch(getVolumesFailure(error)));            

    }
    
}

export default { getVolumes };